import { render, staticRenderFns } from "./TransportationPermissionList.vue?vue&type=template&id=72e44e45"
import script from "./TransportationPermissionList.vue?vue&type=script&lang=ts"
export * from "./TransportationPermissionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports